<template>
    <div class="card-body">
        <template v-if="!form_type">
            <h4 class="card-title text-center">Registreer en begin vandaag je proefperiode.</h4>
            <div class="flex flex-wrap">
                <div class="w-full lg:w-1/2 mt-4 pr-2">
                    <div class="card border">
                        <div class="card-body">
                            <div class="flex flex-md-column justify-between flex-wrap">
                                <div class="flex align-items-center register-option-info">
                                    <div class="block align-self-center pr-4">
                                        <i class="far fa-building text-muted fa-3x"></i>
                                    </div>
                                    <div class="block align-self-center">
                                        <span>Ik ben</span>
                                        <h4 class="card-title">Werkgever</h4>
                                    </div>
                                </div>
                                <div class="text-right">
                                    <button class="mt-4 btn btn-secondary" type="button" @click="switchFormType('employer')">Start je proefperiode <i class="fas fa-chevron-right pl-2"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full lg:w-1/2 mt-4 pl-2">
                    <div class="card border">
                        <div class="card-body">
                            <div class="flex flex-md-column justify-between flex-wrap">
                                <div class="flex align-items-center register-option-info">
                                    <div class="block align-self-center pr-4">
                                        <i class="far fa-user text-muted fa-3x"></i>
                                    </div>
                                    <div class="block align-self-center">
                                        <span>Ik ben</span>
                                        <h4 class="card-title">Werknemer</h4>
                                    </div>
                                </div>
                                <div class="text-right">
                                    <button class="mt-4 btn btn-secondary" type="button"  @click="switchFormType('employee')">Gratis aanmelden <i class="fas fa-chevron-right pl-2"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-2">
                <div class="w-full text-center">
                    <small class="pt-3 form-text text-muted"></small>
                </div>
            </div>
        </template>
        <template v-if="form_type === 'employee'">
            <div class="card-top flex justify-between align-items-center flex-wrap">
                <div class="block align-self-center mb-2">
                    <h4 class="card-title">Registreren als werknemer (gratis)</h4>
                </div>
            </div>
            <div class="flex pb-3">
                <div class="w-full">
                    <span>Wil je jouw vakantiedagen bijhouden? Registreer je <strong>gratis</strong> en profiteer van alle gemakken die Haaer te bieden heeft helemaal kosteloos voor jou als werknemer.</span>
                </div>
            </div>
            <form class="mt-3" method="POST" :action="this.register_route">
                <input type="hidden" name="_token" :value="this.csrf_token" />
                <input type="hidden" name="register_type" value="employee" />
                <input type="hidden" name="phone_number" value="" />
                <div class="form-group flex">
                    <div class="w-full">
                        <label for="employee_register_type">Begin je voor jezelf of ben je uitgenodigd?</label>
                        <select v-model="employee_register_type" class="form-control" id="employee_register_type" name="register_type">
                            <option value="invite">Uitgenodigd</option>
                            <option value="employee">Voor mijzelf</option>
                        </select>
                    </div>
                </div>
                <div class="form-group flex flex-wrap">
                    <div class="w-full sm:w-1/2 mt-2" v-if="this.employee_register_type == 'employee'">
                        <label>Voor welk bedrijf werk je? <small class="text-danger">*</small></label>
                        <input v-model="employee_company_name" v-bind:class="{'is-invalid' : this.errors && this.isInvalid(this.errors.company_name, 'employee')}" type="text" class="form-control" name="company_name" placeholder="Bedrijfsnaam">
                        <small v-if="this.errors && this.errors.company_name && (this.old.register_type == 'employee' || this.old.register_type == 'invite')" class="text-danger">{{this.errors.company_name[0]}}</small>
                    </div>
                    <div class="w-full sm:w-1/2 mt-2 pr-2" v-if="this.employee_register_type == 'invite'">
                        <label>Uitnodigingscode <small class="text-danger">*</small></label>
                        <input v-model="employee_invite_code" v-bind:class="{'is-invalid' : this.errors && this.isInvalid(this.errors.invite_code, 'employee')}" type="text" class="form-control" name="invite_code" placeholder="Uitnodigingscode">
                        <small v-if="this.errors && this.errors.invite_code && (this.old.register_type == 'employee' || this.old.register_type == 'invite')" class="text-danger">{{this.errors.invite_code[0]}}</small>
                    </div>
                    <div class="w-full sm:w-1/2 mt-2 pl-2">
                        <label>E-Mailadres <small class="text-danger">*</small></label>
                        <input v-model="employee_email" v-bind:class="{'is-invalid' : this.errors && this.isInvalid(this.errors.email, 'employee')}" type="email" class="form-control" name="email" placeholder="E-Mail">
                        <small class="block text-muted pt-1">Hiermee log je straks in op Haaer.</small>
                        <small v-if="this.errors && this.errors.email && (this.old.register_type == 'employee' || this.old.register_type == 'invite')" class="text-danger">{{this.errors.email[0]}}</small>
                    </div>
                </div>
                <div class="form-group flex flex-wrap">
                    <div class="w-full md:w-1/2 mt-2 pr-2">
                        <label>Voornaam <small class="text-danger">*</small></label>
                        <input v-model="employee_first_name" v-bind:class="{'is-invalid' : this.errors && this.isInvalid(this.errors.first_name, 'employee')}" type="text" class="form-control" name="first_name" placeholder="Voornaam">
                        <small v-if="this.errors && this.errors.first_name && (this.old.register_type == 'employee' || this.old.register_type == 'invite')" class="text-danger">{{this.errors.first_name[0]}}</small>
                    </div>
                    <div class="w-full md:w-1/2 mt-2 pl-2">
                        <label>Achternaam <small class="text-danger">*</small></label>
                        <input v-model="employee_surname" v-bind:class="{'is-invalid' : this.errors && this.isInvalid(this.errors.surname, 'employee')}" type="text" class="form-control" name="surname" placeholder="Achternaam">
                        <small v-if="this.errors && this.errors.surname && (this.old.register_type == 'employee' || this.old.register_type == 'invite')" class="text-danger">{{this.errors.surname[0]}}</small>
                    </div>
                </div>
                <div class="form-group flex flex-wrap">
                    <div class="w-full md:w-1/2 mt-2 pr-2">
                        <label>Wachtwoord <small class="text-danger">*</small></label>
                        <input v-model="employee_password" v-bind:class="{'is-invalid' : this.errors && this.isInvalid(this.errors.password, 'employee')}" type="password" class="form-control" name="password" placeholder="******">
                        <small v-if="this.errors && this.errors.password && (this.old.register_type == 'employee' || this.old.register_type == 'invite')" class="text-danger">{{this.errors.password[0]}}</small>
                    </div>
                    <div class="w-full md:w-1/2 mt-2 pl-2">
                        <label>Wachtwoord Bevestigen <small class="text-danger">*</small></label>
                        <input v-model="employee_password_confirmation" type="password" class="form-control" name="password_confirmation" placeholder="******">
                    </div>
                </div>
                <div class="custom-control custom-checkbox mb-2">
                    <input v-model="employee_terms_agreement" type="checkbox" class="custom-control-input" name="terms_agreement" id="b2b_terms_agreement">
                    <label class="text-small custom-control-label" for="b2b_terms_agreement">Ik ga akkoord met de <a class="text-primary" :href="terms_employee_route" target="_blank">algemene voorwaarden</a> en <a class="text-primary" :href="avg_agreement_route" target="_blank">privacyverklaring</a>. <small class="text-danger">*</small></label>
                    <small v-if="this.errors && this.errors.terms_agreement && (this.old.register_type == 'employee' || this.old.register_type == 'invite')" class="text-danger d-block">{{this.errors.terms_agreement[0]}}</small>
                </div>
                <div class="form-group flex flex-wrap">
                    <div class="w-full md:w-1/2 mt-2">
                        <button type="submit" class="btn btn-secondary btn-block">
                            Registreer
                        </button>
                    </div>
                    <div class="w-full md:w-1/2 mt-2">
                        <div class="flex justify-between align-items-center flex-wrap">
                            <small class="form-text text-muted mt-2"></small>
                            <p class="mb-0 mt-2"><small class="text-danger">*</small> verplichte velden</p>
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template v-else-if="form_type === 'employer'">
            <div class="card-top flex justify-between align-items-center flex-wrap">
                <div class="block align-self-center mb-2">
                    <h4 class="card-title">Registreren als werkgever (14 dagen proefperiode)</h4>
                </div>
            </div>
            <div class="flex pb-3">
                <div class="w-full">
                    <span>Registreer je als werkgever en probeer alle functionaliteiten van Haaer de komende 14 dagen helemaal <strong>gratis</strong> uit!</span>
                </div>
            </div>
            <form method="POST" :action="this.register_route">
                <input type="hidden" name="_token" :value="this.csrf_token">
                <input type="hidden" name="register_type" value="employer">
                <div class="form-group flex flex-wrap">
                    <div class="w-full md:w-1/2 mt-2 pr-2">
                        <label>Bedrijfsnaam <small class="text-danger">*</small></label>
                        <input v-model="employer_company_name" v-bind:class="{'is-invalid' : this.errors && this.isInvalid(this.errors.company_name, 'employer')}" type="text" class="form-control" name="company_name" placeholder="Bedrijfsnaam">
                        <small v-if="this.errors && this.errors.company_name && this.old.register_type == 'employer'" class="text-danger">{{this.errors.company_name[0]}}</small>
                    </div>
                    <div class="w-full md:w-1/2 mt-2 pl-2">
                        <label>E-Mailadres <small class="text-danger">*</small></label>
                        <input v-model="employer_email" v-bind:class="{'is-invalid' : this.errors && this.isInvalid(this.errors.email, 'employer')}" type="email" class="form-control" name="email" placeholder="E-Mail">
                        <small class="block text-muted pt-1">Hiermee log je straks in op Haaer.</small>
                        <small v-if="this.errors && this.errors.email && this.old.register_type == 'employer'" class="text-danger">{{this.errors.email[0]}}</small>
                    </div>
                </div>
                <div class="form-group flex flex-wrap">
                    <div class="w-full md:w-1/2 mt-2 pr-2">
                        <label>Telefoonnummer</label>
                        <input v-model="employer_phone_number" v-bind:class="{'is-invalid' : this.errors && this.isInvalid(this.errors.phone_number, 'employer')}" type="text" class="form-control" name="phone_number" placeholder="Vast of mobiel">
                        <small v-if="this.errors && this.errors.phone_number && this.old.register_type == 'employer'" class="text-danger">{{this.errors.phone_number[0]}}</small>
                    </div>
                </div>
                <div class="form-group flex flex-wrap">
                    <div class="w-full md:w-1/2 mt-2 pr-2">
                        <label>Voornaam <small class="text-danger">*</small></label>
                        <input v-model="employer_first_name" v-bind:class="{'is-invalid' : this.errors && this.isInvalid(this.errors.first_name, 'employer')}" type="text" class="form-control" name="first_name" placeholder="Voornaam">
                        <small v-if="this.errors && this.errors.first_name && this.old.register_type == 'employer'" class="text-danger">{{this.errors.first_name[0]}}</small>
                    </div>
                    <div class="w-full md:w-1/2 mt-2 pl-2">
                        <label>Achternaam <small class="text-danger">*</small></label>
                        <input v-model="employer_surname" v-bind:class="{'is-invalid' : this.errors && this.isInvalid(this.errors.surname, 'employer')}" type="text" class="form-control" name="surname" placeholder="Achternaam">
                        <small v-if="this.errors && this.errors.surname && this.old.register_type == 'employer'" class="text-danger">{{this.errors.surname[0]}}</small>
                    </div>
                </div>
                <div class="form-group flex flex-wrap">
                    <div class="w-full md:w-1/2 mt-2 pr-2">
                        <label>Wachtwoord <small class="text-danger">*</small></label>
                        <input v-model="employer_password" v-bind:class="{'is-invalid' : this.errors && this.isInvalid(this.errors.password, 'employer')}" type="password" class="form-control" name="password" placeholder="******">
                        <small v-if="this.errors && this.errors.password && this.old.register_type == 'employer'" class="text-danger">{{this.errors.password[0]}}</small>
                    </div>
                    <div class="w-full md:w-1/2 mt-2 pl-2">
                        <label>Wachtwoord Bevestigen <small class="text-danger">*</small></label>
                        <input v-model="employer_password_confirmation" type="password" class="form-control" name="password_confirmation" placeholder="******">
                    </div>
                </div>
                <div class="custom-control custom-checkbox mb-2">
                    <input v-model="employer_terms_agreement" type="checkbox" class="custom-control-input" name="terms_agreement" id="b2c_terms_agreement">
                    <label class="text-small custom-control-label" for="b2c_terms_agreement">Ik ga akkoord met de <a class="text-primary" :href="terms_employer_route" target="_blank">algemene voorwaarden</a> en <a class="text-primary" :href="avg_agreement_route" target="_blank">privacyverklaring</a>. <small class="text-danger">*</small></label>
                    <small v-if="this.errors && this.errors.terms_agreement && this.old.register_type == 'employer'" class="d-block text-danger">{{this.errors.terms_agreement[0]}}</small>
                </div>
                <div class="form-group flex">
                    <div class="w-full sm:w-1/2 mt-2">
                        <button type="submit" class="btn btn-secondary btn-block">Registreer</button>
                    </div>
                    <div class="w-full sm:w-1/2 mt-2">
                        <div class="flex justify-between align-items-center flex-wrap">
                            <small class="form-text text-muted mt-2"></small>
                            <p class="mb-0 mt-2"><small class="text-danger">*</small> verplichte velden</p>
                        </div>
                    </div>
                </div>
            </form>
        </template>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                form_type: undefined,
                switch_form_btn_content: 'werkgever',
                employee_register_type: 'invite',
                employee_company_name: '',
                employee_email: '',
                employee_first_name: '',
                employee_surname: '',
                employee_invite_code: '',
                employee_password: '',
                employee_password_confirmation: '',
                employee_terms_agreement: false,
                employee_avg_agreement: false,
                employer_company_name: '',
                employer_email: '',
                employer_phone_number: '',
                employer_first_name: '',
                employer_surname: '',
                employer_password: '',
                employer_password_confirmation: '',
                employer_terms_agreement: false,
                employer_avg_agreement: false,
            }
        },
        props: {
            register_route: String,
            login_route: String,
            csrf_token: String,
            errors: {},
            old: {},
            terms_employee_route: String,
            terms_employer_route: String,
            avg_agreement_route: String,
            code: String,
            email: String,
        },
        mounted() {
            if (this.old !== undefined) {
                if (this.old.register_type === 'employee' || this.old.register_type === 'invite') {
                    if(this.old.register_type === 'invite') {
                        this.employee_register_type = 'invite';
                    }

                    this.employee_company_name = this.old.company_name;
                    this.employee_email = this.old.email;
                    this.employee_first_name = this.old.first_name;
                    this.employee_surname = this.old.surname;
                    this.employee_invite_code = this.old.invite_code;

                    if (this.old.terms_agreement) {
                        this.employee_terms_agreement = true;
                    }

                    if (this.old.avg_agreement) {
                        this.employee_avg_agreement = true;
                    }

                    this.switchFormType('employee');
                } else if (this.old.register_type === 'employer') {
                    this.employer_company_name = this.old.company_name;
                    this.employer_email = this.old.email;
                    this.employer_phone_number = this.old.phone_number;
                    this.employer_first_name = this.old.first_name;
                    this.employer_surname = this.old.surname;

                    if (this.old.terms_agreement) {
                        this.employer_terms_agreement = true;
                    }

                    if (this.old.avg_agreement) {
                        this.employer_avg_agreement = true;
                    }

                    this.switchFormType('employer');
                }
            }
            if (this.code !== undefined) {
                this.employee_register_type = 'invite';
                this.employee_invite_code = this.code;
                this.switchFormType('employee');
            }
            if (this.email !== undefined) {
                this.employee_email = this.email;
                this.employer_email = this.email;
            }
        },
        methods: {
            switchFormType: function (type) {
                switch (type) {
                    case "employer":
                        this.form_type = 'employer';
                        this.employer_email = this.email;
                        break;

                    default:
                        this.form_type = 'employee';
                        this.employee_email = this.email;
                        break;
                }
            },
            isInvalid: function (error_field, register_type) {
                if (error_field && register_type === 'employee' && this.old.register_type === 'invite') {
                    return true;
                }

                return error_field && this.old.register_type === register_type;
            },
        }
    }
</script>
